import { render, staticRenderFns } from "./answerSheet_new.vue?vue&type=template&id=66b60fe1&scoped=true"
import script from "./answerSheet_new.vue?vue&type=script&lang=js"
export * from "./answerSheet_new.vue?vue&type=script&lang=js"
import style0 from "./answerSheet_new.vue?vue&type=style&index=0&id=66b60fe1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b60fe1",
  null
  
)

export default component.exports